/* eslint-disable */

<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card class="mb-base">
        <div class="">
          <div class="simulation-10">
            <div class="vx-row mt-3 mb-16">
              <div class="vx-col w-4/12 center-2"></div>
              <div class="vx-col w-4/12 center-2"></div>
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-block flex items-center align-middle" style="background-color: #FBBF24">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/823309597501685794/dns.png"
                    width="60"></div>
                  <div class="ml-4 mr-2 items-center">
                    <h3>DNS Provider</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.dns_provider"/>
                  </div>
                </div>
                <div class="line-dns-internet"></div>
                <div class="line-dns-internet-connect"></div>
                <div class="line-down-right"></div>
              </div>
            </div>
            <div class="vx-row my-12 ">
              <div class="vx-col w-4/12 center-2 f1-pull-up">
                <div class="tenth-firewall-color flex items-center align-middle">
                  <div class="tenth-image-block ml-2"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793709704307933224/wall-2.png"
                    width="60"></div>
                  <div class="ml-4 mr-2">
                    <h3>Firewall 1</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.firewall_one"/>
                  </div>
                </div>
                <div class="line-down-left"></div>
                <div class="line-f1-internet"></div>
              </div>
              <div class="vx-col w-4/12 center-2 f1-pull-up">
                  <div class="tenth-block flex items-center align-middle" style="background-color: #3B82F6">
                    <div class="tenth-image-block">
                      <img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823307570826575973/internet.png" width="60"></div>
                    <h2 class="ml-3 mr-2">Internet</h2>
                  </div>
              </div>
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-firewall-color flex items-center align-middle">
                  <div class="tenth-image-block ml-2"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793709704307933224/wall-2.png"
                    width="60"></div>
                  <div class="ml-4 mr-2">
                    <h3>Firewall 2</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.firewall_two"/>
                  </div>
                </div>
                <div class="line-dns-internet"></div>
              </div>
            </div>
            <div class="vx-row my-12 ">
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-block flex items-center align-middle"  style="background-color: #DB2777">
                  <div class="tenth-image-block ml-2"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/823309573138022430/wireless-router.png"
                    width="60"></div>
                  <div class="ml-4 mr-2">
                    <h3>Router 1</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.router_one"/>
                  </div>
                </div>
                <div class="line-f1-internet"></div>
              </div>
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-block bg-danger flex items-center align-middle">
                  <div class="tenth-image-block">
                    <img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/822162681011896330/822232883975815185/lightning.png" width="60"></div>
                    <h3 class="ml-3 mr-2">Site-to-Site IPSEC Tunnel</h3>
                </div>
              </div>
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-block flex items-center align-middle"  style="background-color: #DB2777">
                  <div class="tenth-image-block ml-2"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/823309573138022430/wireless-router.png"
                    width="60"></div>
                  <div class="ml-4 mr-2">
                    <h3>Router 2</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.router_two"/>
                  </div>
                </div>
                <div class="line-dns-internet-router"></div>
              </div>
            </div>
            <div class="vx-row my-12">
              <div class="vx-col w-4/12 center-2"></div>
              <div class="vx-col w-4/12 center-2"></div>
              <div class="vx-col w-4/12 center-2">
                <div class="tenth-block flex items-center align-middle" style="background-color: #5B21B6">
                  <div class="tenth-image-block ml-2"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png"
                    width="60"></div>
                  <div class="ml-4 mr-2">
                    <h3>Load Balancer</h3>
                    <vs-switch color="success" class="mt-1" v-model="switches_enabled.load_balancer"/>
                  </div>
                </div>

              </div>
            </div>
            <div class="vx-row my-12">
              <div class="vx-col w-5/12 center-2">
                <div class="tenth-block" style="background-color: #4F46E5">
                  <div class="m-2">
                    <h1 class="mb-1 text-center ">10.1.1.0/24</h1>
                    <div class="flex items-center align-middle">
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <p class="text-center">Orchestration <br> Server</p>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.server.orc"/>
                        </div>
                      </div>
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <p class="text-center">Application <br> Server</p>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.server.app"/>
                        </div>
                      </div>
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <p class="text-center">Database <br> Server</p>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.server.db"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-2/12 center-2"></div>
              <div class="vx-col w-5/12 center-2">
                <div class="tenth-block" style="background-color: #4F46E5">
                  <div class="m-2">
                    <h1 class="mb-1 text-center ">10.1.2.0/24</h1>
                    <div class="flex items-center align-middle">
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.cluster.switch_one"/>
                        </div>
                      </div>
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.cluster.switch_two"/>
                        </div>
                      </div>
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.cluster.switch_three"/>
                        </div>
                      </div>
                      <div class="m-2">
                        <div class="tenth-image-block m-2"><img draggable="false" alt="" class="tenth-image" src="https://cdn.discordapp.com/attachments/746242308084858900/823310101334851584/distribution.png" width="60"></div>
                        <div class="flex items-center justify-center">
                          <vs-switch color="success" class="mt-1" v-model="switches_enabled.cluster.switch_four"/>
                        </div>
                      </div>
                    </div>
                    <h3 class="mt-2 text-center">Application Server Cluster</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <vs-popup title="Complete Part Two" :active.sync="show_part_two">
      <h2>Only select a maximum of TWO options</h2>
      <vs-divider></vs-divider>
      <div class="flex mb-6">
        <h5>Deploy a Replica of the Database Server in the Cloud Provider</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.one"/>
      </div>
      <div class="flex my-6">
        <h5>Update the PSK (Pre-shared key) in Router 2</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.two"/>
      </div>
      <div class="flex my-6">
        <h5>Update the A record on the DNS from 2.2.2.2 to 1.1.1.1</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.three"/>
      </div>
      <div class="flex my-6">
        <h5>Promote deny All to allow All in Firewall1 and Firewall2</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.four"/>
      </div>
      <div class="flex my-6">
        <h5>Change the Address Space on Router2</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.five"/>
      </div>
      <div class="flex my-6">
        <h5>Change internal IP Address of Router 1</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.six"/>
      </div>
      <div class="flex my-6">
        <h5>CReverse the Weight property in the two CNAME records on the DNS</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.seven"/>
      </div>
      <div class="flex my-6">
        <h5>Add the Application Server at on-premises to the Load Balancer</h5>
        <vs-switch color="success" class="ml-2" v-model="switches_enabled.part_two.eight"/>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      show_part_two: false,

      switches_enabled: {
        firewall_one: false,
        firewall_two: false,
        dns_provider: false,
        router_one: false,
        router_two: false,
        load_balancer: false,
        cluster: {
          switch_one: false,
          switch_two: false,
          switch_three: false,
          switch_four: false
        },
        server: {
          orc: false,
          app: false,
          db: false
        },
        part_two: {
          one: false,
          two: false,
          three: false,
          four: false,
          five: false,
          six: false,
          seven: false,
          eight: false
        }
      }


    }
  },
  watch: {
    'switches_enabled.part_two.one' () {
      this.check_part_two()
    },
    'switches_enabled.part_two.two' () {
      this.check_part_two()

    }
  },
  methods: {
    markSimulation () {

      let total_score = 0
      if (this.switches_enabled.dns_provider === true) {
        total_score++
      }
      if (this.switches_enabled.router_two) {
        total_score++
      }

      if (total_score === 2) {
        this.show_part_two = true
        setTimeout(() => {
          this.$emit('enable_mark_button')
        }, 50)
      } else {
        this.$emit('simulation_getting_there', total_score)
      }

    },
    check_part_two () {

      // const correct = 0

      // Object.entries(this.switches_enabled.part_two).forEach(entry => {
      //  const [key, value] = entry

      // })

    }
  },
  components: {
    Prism,
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/views/simulations/legacy/css/CompTIA/Cloud+//Lgx209045111810555904.scss";

.vs-switch {
  background: #000000ab;
}

</style>

